/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, prettyRatio: NonNullable<unknown>, metric: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Validators_Or_Miners_Left_BetterInputs */



/**
* | output |
* | --- |
* | "{leftChain} has {prettyRatio} more {metric} than {rightChain}" |
*
* @param {Chain_Page_Compare_Validators_Or_Miners_Left_BetterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_validators_or_miners_left_better = /** @type {((inputs: Chain_Page_Compare_Validators_Or_Miners_Left_BetterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Validators_Or_Miners_Left_BetterInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} has ${i?.prettyRatio} more ${i?.metric} than ${i?.rightChain}`)
});